export default __webpack_public_path__ + "static/NeueHaasUnicaProBold-6880ffd4cda7073c0a43816b9d345d8d.woff";